module.exports = __webpack_public_path__ + "img/logo.f4ac8975.png";